module.exports = __webpack_public_path__ + "static/ultraleap-logo-30044f6e43261aee6b25b5098ea865be.png";